import { useCallback } from 'react';

import Text from '@zenbusiness/common-components/Text';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import { useBreakpoints } from '#client/pages/EducationStudio/hooks/useBreakpoints';

import { useLessonStorage } from '../../../hooks';
import { ExercisePage, MAX_CHARACTER_COUNT } from '../../Interactive/WorksheetActivity/exercisePage';
import {
  StyledImageContainer,
  StyledList, StyledNextButton,
  StyledSharedAsset,
  StyledText, StyledTextArea
} from '../../Interactive/WorksheetActivity/useStyles';

const NEXT_BUTTON_TEXT = 'Next';
export const YOUR_THOUGHT_LEADERSHIP_MUSE = 'yourThoughtLeadershipMuse';

export const YourThoughtLeadershipMuse = ({ onNext }) => {
  const { lesson } = useParams();
  const { getStorageValue, setStorageValue, saveChanges } = useLessonStorage(lesson);
  const {
    sizes: { isMobile }
  } = useBreakpoints();

  const onNextHandler = useCallback(() => {
    saveChanges();
    onNext();
  }, [saveChanges, onNext]);

  const presentation = (
    <StyledImageContainer>
      <StyledSharedAsset
        src="/journey to success/01 MVE Series/07 MUSE/mve_muse_exercise7.svg"
        alt="muse-exercise"
        width={500}
      />
    </StyledImageContainer>
  );

  return (
    <ExercisePage
      caption="Exercise"
      title="Your thought-leadership muse"
      presentation={presentation}
      buttonText={NEXT_BUTTON_TEXT}
      isButtonDisabled={!getStorageValue(YOUR_THOUGHT_LEADERSHIP_MUSE)}
      onNext={onNextHandler}
    >
      <StyledText>
        Sixth, let&apos;s find your thought-leadership muse.
        Whose style of though leadership will you adopt in your business?
      </StyledText>
      <Text size={isMobile ? 'lg' : 'sm'} bold>You might love this muse&apos;s thought-leadership style because of their:</Text>
      <StyledList>
        <li>
          <Text size={isMobile ? 'lg' : 'sm'}>Relatability</Text>
        </li>
        <li>
          <Text size={isMobile ? 'lg' : 'sm'}>Inspiration</Text>
        </li>
        <li>
          <Text size={isMobile ? 'lg' : 'sm'}>Dynamism</Text>
        </li>
      </StyledList>
      <StyledTextArea
        placeholder="My thought-leadership muse is..."
        text={getStorageValue(YOUR_THOUGHT_LEADERSHIP_MUSE)}
        onChangeHandler={(e) => setStorageValue(YOUR_THOUGHT_LEADERSHIP_MUSE, e.target.value)}
        maxLength={MAX_CHARACTER_COUNT}
      />
      {!isMobile && (
      <StyledNextButton
        variant="contained"
        color="primary"
        size="large"
        disabled={!getStorageValue(YOUR_THOUGHT_LEADERSHIP_MUSE)}
        onClick={() => onNextHandler()}
      >
        {NEXT_BUTTON_TEXT}
      </StyledNextButton>
      )}
    </ExercisePage>
  );
};

YourThoughtLeadershipMuse.propTypes = {
  onNext: PropTypes.func
};

YourThoughtLeadershipMuse.defaultProps = {
  onNext: () => {}
};

export default YourThoughtLeadershipMuse;
